"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiItalic = function IconUiItalic(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M27.463 42.837l-3.269-.444a2.338 2.338 0 0 1-1.33-.886 2.3 2.3 0 0 1-.277-1.219 22.911 22.911 0 0 1 .942-4.1l6.759-24.155a22.439 22.439 0 0 1 1.939-4.875 4.77 4.77 0 0 1 1.939-1.607 6.7 6.7 0 0 1 2.826-.443L37.269 4H21.978l-.554 1.108a12.043 12.043 0 0 1 3.213.277 3.1 3.1 0 0 1 1.108.831 2.474 2.474 0 0 1 .277 1.219 19.883 19.883 0 0 1-.775 4.6l-6.926 24.153a14.7 14.7 0 0 1-2.105 4.876 4.881 4.881 0 0 1-1.884 1.44 9.544 9.544 0 0 1-3.157.333L10.731 44h16.455z"
  }));
};

IconUiItalic.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiItalic;
exports.default = _default;